import React, { useState } from "react";
import Zipcode from "../../components/Zipcode/Zipcode";
import Email from "../../components/Email/Email";
import {
  DefaultPersonIDPData,
  DefaultZipData,
  IPersonIDPData,
  IZipData,
  RegistrationComponentLoad,
} from "../../types/ApplicationTypes";
import IDPNotExists from "../../components/IDPNotExists/IDPNotExists";
import PersonMatch from "../../components/PersonMatch/PersonMatch";
import Message from "../../components/Message/Message";
import SingleWandaEmailValidation from "../../components/SingleWandaEmailValidation/SingleWandaEmailValidation";
import ResetPassword from "../../components/ResetPassword/ResetPassword";

type Props = {};

const RegistrationContainer: React.FC<Props> = ({}) => {
  const [pageType, setPageType] = useState<string>("");
  const [emailId, setEmailId] = useState<string>("");
  const [personData, setPersonData] = useState<IPersonIDPData>(
    DefaultPersonIDPData()
  );
  const [personId, setPersonId] = useState<number>(0);
  const [wandaEmailId, setWandaEmailId] = useState<string>("");
  const [zipData, setZipData] = useState<IZipData>(DefaultZipData);
  const [wandaOrgId, setWandaOrgId] = useState<number>(0);

  return <div>{componentSwitch(pageType)}</div>;

  function componentSwitch(pageType: any) {
    switch (pageType) {
      case RegistrationComponentLoad.Email:
        return (
          <Email
            setPageType={setPageType}
            setEmailId={setEmailId}
            zipData={zipData}
            setWandaEmailId={setWandaEmailId}
          ></Email>
        );
      case RegistrationComponentLoad.ZipCode:
        return (
          <Zipcode
            setPageType={setPageType}
            setZipData={setZipData}
            setWandaOrgId={setWandaOrgId}
          ></Zipcode>
        );
      case RegistrationComponentLoad.IDPNotExists:
        return (
          <IDPNotExists
            setPageType={setPageType}
            emailId={emailId}
            setPersonData={setPersonData}
            wandaOrgId={wandaOrgId}
          ></IDPNotExists>
        );
      case RegistrationComponentLoad.PersonMatch:
        return (
          <PersonMatch
            pageType={pageType}
            setPageType={setPageType}
            personData={personData}
            setPersonId={setPersonId}
            setWandaEmailId={setWandaEmailId}
            wandaOrgId={wandaOrgId}
          ></PersonMatch>
        );
      case RegistrationComponentLoad.Message:
        return <Message emailId={emailId}></Message>;
      case RegistrationComponentLoad.SingleWandaEmailValidation:
        return (
          <SingleWandaEmailValidation
            wandaEmailId={wandaEmailId}
            personId={personId}
            setPageType={setPageType}
          ></SingleWandaEmailValidation>
        );
      case RegistrationComponentLoad.ResetPassword:
        return <ResetPassword wandaEmailId={wandaEmailId}></ResetPassword>;
      default:
        return (
          <Zipcode
            setPageType={setPageType}
            setZipData={setZipData}
            setWandaOrgId={setWandaOrgId}
          ></Zipcode>
        );
    }
  }
};

export default RegistrationContainer;
